<template>
<div style="height: 1400px;">
  <json-view
    :data="dstatus"
    rootKey="view"
    :maxDepth="3"
    :styles=defaultStyles
  />
  </div>
</template>

<script>
export default {
data () {
    return {
      dstatus: {},
      schema_tmp: {},
       defaultStyles: {
          key: "#002b36",
          valueKey: "#073642",
          string: "#268bd2",
          number: "#2aa198",
          boolean: "#cb4b16",
          null: "#6c71c4",
          arrowSize: "6px"
        }
      }
    },
    

   mounted() {
         if(localStorage.getItem('access_token')!=null){ this.$http.defaults.headers.common['X-Authorization'] =  localStorage.getItem('access_token');}

    this.$http
      .get(this.$root.apiUrl+'/api/v1/schemas/instances.json')
      .then(response => {
          this.schema_tmp = response.data; 
        
        this.$http
            .get(this.$root.apiUrl + '/api/v1/instances_status/' + this.$route.params.id)
            .then(response => {
                this.dstatus = JSON.parse(JSON.stringify(response.data))  ;
                });
        }
      )},

    methods: {

  }
}
</script>

<style>

</style>


// WEBPACK FOOTER //
// src/pages/projects/status.vue